var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHatMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07871 6.71217C2.33005 7.0106 1.89092 7.78827 2.02348 8.58088L3.51023 17.4707C3.6864 18.5241 4.72672 19.2038 5.76636 18.9448C9.85914 17.9251 14.1409 17.9251 18.2336 18.9448C19.2733 19.2038 20.3136 18.5241 20.4898 17.4707L21.9765 8.58088C22.1091 7.78827 21.6699 7.0106 20.9213 6.71217C15.1943 4.42928 8.80565 4.42928 3.07871 6.71217ZM11.2858 7.22331H12.7143C12.996 7.22331 13.2244 7.45094 13.2244 7.73174V10.0705H15.5712C15.853 10.0705 16.0814 10.2981 16.0814 10.5789V12.0025C16.0814 12.2833 15.853 12.5109 15.5712 12.5109H13.2244V14.8497C13.2244 15.1305 12.996 15.3581 12.7143 15.3581H11.2858C11.004 15.3581 10.7756 15.1304 10.7756 14.8497V12.5109H8.42875C8.14699 12.5109 7.91857 12.2833 7.91857 12.0025V10.5789C7.91857 10.2981 8.14699 10.0705 8.42875 10.0705H10.7756V7.73174C10.7756 7.45094 11.004 7.22331 11.2858 7.22331Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatMedical);
export default __webpack_public_path__ + "static/media/hat-medical.4d35ff43e9f5b77ff6822db3aa01f0f9.svg";
export { ForwardRef as ReactComponent };